
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";

import api from "@/api";
import { UserCardLogDto, UserCardLogType } from "@/api/appService";
import filter from "@/utils/filter";

@Component
export default class UserCardLogs extends Vue {
  @Watch("show")
  async onShowChange(value: boolean) {
    if (value) {
    } else {
    }
  }

  logs: UserCardLogDto[] = [];

  private internalLogs:any = [];



  show = false;

  @Watch('logs')
  onLogsChange(newValue:UserCardLogDto[]){
    if(newValue && newValue.length){
      this.internalLogs = [];
      for(let i = 0;i<newValue.length;i++){
        let logItem:any = newValue[i];
        if(logItem.type === 'Deduction'){
          logItem.hasRevoked = false;
          for(let j = 0;j< newValue.length;j++){
            let checkItem = newValue[j];
            if(checkItem.id  === logItem.id)
              continue;
            if(checkItem.billNo === logItem.billNo && checkItem.type === 'Revoke'){
              logItem.hasRevoked = true;
              break;
            }
          }

        }
        this.internalLogs.push(logItem);
      }
    } else {
      this.internalLogs = newValue;
    }
  }

  async handleRevoke(row: UserCardLogDto) {
    await api.userCard
      .revoke({
        billNo: row.billNo,
        desc: `${this.$store.getters['user/name']} 撤销了这笔扣款`
      })
      .then(res => {
        this.$message.success("撤销成功");
        this.show = false;
        this.$emit("onSave");
      });
  }

  cancel() {
    this.show = false;
  }

  formatNodeText(log: UserCardLogDto) {
    if (log.type !== "Deduction") {
      return log.desc;
    } else {
      return `${log.desc} 扣款周期:${log.period}, 扣除金额:￥${log.ammount}`;
    }
  }
  // log types

  formatCreationTime(time: string) {
    return filter.formatDate(time, undefined);
  }

  formatNodeType(log: UserCardLogDto) {
    // primary / success / warning / danger / info
    switch (log.type) {
      case UserCardLogType.Canceled:
      case UserCardLogType.UnKnow:
      case UserCardLogType.Delay:
      case UserCardLogType.Refunding:
        return "default";
      case UserCardLogType.Revoke:
        return "danger";
      case UserCardLogType.Deduction:
      case UserCardLogType.StartUse:
        return "primary";
      case UserCardLogType.Enable:
        return "success";
      case UserCardLogType.Freeze:
        return "danger";
      default:
        return "default";
    }
  }
  formatLogIcon(log: UserCardLogDto) {
    switch (log.type) {
      case UserCardLogType.Canceled:
        return "el-icon-refresh-right";
      case UserCardLogType.Delay:
        return "el-icon-alarm-clock";
      case UserCardLogType.Refunding:
        return "el-icon-refresh-right";
      case UserCardLogType.Revoke:
        return "el-icon-refresh-left";
      case UserCardLogType.Deduction:
        return "el-icon-postcard";
      case UserCardLogType.StartUse:
        return "el-icon-alarm-clock";
      case UserCardLogType.Enable:
        return "el-icon-unlock";
      case UserCardLogType.Freeze:
        return "el-icon-lock";
      case UserCardLogType.UnKnow:
      default:
        return "el-icon-question";
    }
  }
}
